<ng-container *ngIf="isVisibleSubject">
    <ng-container *ngIf="isVisibleSubject | async">
        <div class="overlay">
            Esto funcioooooooooooonaaaaa jejeje
        </div>
    </ng-container>
</ng-container>